import React from 'react';

type btnInput = {
  text: any,
  additionalClasses?: string,
  onClick: any
};
const CircularBtn: React.FC<btnInput> = ({
  onClick, additionalClasses, text, children,
}) => (

  <button
    onClick={onClick}
    type="button"
    className={`flex items-center justify-center ${additionalClasses}`}
  >
    {text}
    <span className="ml-4">
      {children}
    </span>
  </button>
);
export default (CircularBtn);
